import { useState } from "react";
import kesaiSrc from '../../../assets/img/kesai-scan.png';
import styles from "./index.module.scss";


export const MobileAlgo = () => {
  const [showCode, setShowCode] = useState(false)
  return (
    <div className={styles.page}>
      <div className={styles["top-bg"]}></div>
      <div className={styles["logo"]}></div>

      <div className={styles["title-intro"]} id="anchor-intro"></div>
      <div className={styles["text-intro"]}></div>

      <div className={styles["title-setup"]} id="anchor-setup"></div>

      <div className={styles["quiz1"]}></div>
      <div className={styles["quiz2"]}></div>
      
      <div className={styles["quiz-content1"]}></div>
      <div className={styles["quiz-content2"]}></div>
      
      <div className={styles["btn-entry1"]} onClick={() => setShowCode(!showCode)}></div>
      {showCode && <div className={styles["kesai-scan"]}>
        <img src={kesaiSrc} alt="可赛小程序码" />
      </div>}
      <div
        className={styles["btn-entry2"]}
        onClick={() => {
          window.open(
            "https://gigavision.cn/track/track?nav=Sparse%20rendering&type=nav&t=1677659333299",
            "_blank"
          );
        }}
      ></div>

      <div
        className={styles["title-schedule"]}
        id="anchor-schedule"
      ></div>

      <div className={styles["contest-timeline1"]}></div>
      <div className={styles["contest-timeline2"]}></div>
      
      <div
        className={styles["title-participants"]}
        id="anchor-participants"
      ></div>
      <div className={styles["text-participants"]}></div>

      <div className={styles["title-guests"]} id="anchor-guests"></div>
      <div className={styles["guests"]}></div>

      <div className={styles["title-prizes"]} id="anchor-prizes"></div>
      <div className={styles["prizes1"]}></div>
      <div className={styles["prizes2"]}></div>

      <div className={styles["title-contact"]} id="anchor-contact"></div>
      <div className={styles["text-contact"]}></div>

      <div className={styles["footer"]}></div>
    </div>
  );
};
